import { takeEvery } from 'redux-saga/effects';
import * as types from './actionTypes.unloadPage';
import * as errorSaga from '../errors/saga.errors';
import { IBaseAction } from '../base';

export function* watch() {
    yield takeEvery<IUnloadWarningForProjectParams & IBaseAction>(types.UPDATE_BEFORE_UNLOAD_LISTENER_BECAUSE_OF_LEAVING_PROJECT_REQ, updateBeforeUnloadWarningForProject);
    yield takeEvery<IUnloadWarningForBillingParams & IBaseAction>(types.UPDATE_BEFORE_UNLOAD_LISTENER_BECAUSE_OF_LEAVING_FROM_BILLING_REQ, updateBeforeUnloadWarningForBilling);
}

export interface IUnloadWarningForProjectParams {
    hasListener: boolean;
}

export function* updateBeforeUnloadWarningForProject({ hasListener }: IUnloadWarningForProjectParams) {
    try {
        if (hasListener) {
            window.onbeforeunload = onUnload;
        } else {
            window.onbeforeunload = null;
        }
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export interface IUnloadWarningForBillingParams {
    hasListener: boolean;
}

export function* updateBeforeUnloadWarningForBilling({ hasListener }: IUnloadWarningForBillingParams) {
    try {
        // if (hasListener) {
        //     window.onbeforeunload = onUnload;
        // } else {
        //     window.onbeforeunload = null;
        // }
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

function onUnload(e) {
    const message = "You have unsaved changes in scripts. Are you sure you want to leave Alan AI Studio?";

    if (typeof e == 'undefined') {
        e = window.event;
    }
    if (e) {
        e.returnValue = message;
    }
    return message;
}
